import React, { useEffect } from 'react'
import { FormModal, FormInput, SelectPaymentOptions } from '../../../../onestep-library/BaseUI'
import { useSelector, useDispatch } from 'react-redux'
import { submitMakePaymentForm, updateMakePaymentField } from './actions'
import { injectStripe } from 'react-stripe-elements'
import { getCurrentTimeWithCurrentTimezone } from '../../../../../../utils'
import PaySimpleTransactionFee from "../../../Account/components/PaySimpleTransactionFee";

function MakePayment(props){
  const dispatch = useDispatch()
  const { makePaymentForm, organization, resident } = useSelector(state=>state)
  const { ui, payment_source, memo, amount, due_by, name, id, payer, balance, email, errors, paid_at, issued_at, description='', max_current_date } = makePaymentForm
  const { is_submitting, show } = ui
  const paySimplePMTRef = React.useRef();
  const [paySimpleCardValid, setPaySimpleCardValid] = React.useState(true);

  const updateMakePaymentFieldAction = (payload) => dispatch(updateMakePaymentField(payload))
  
  function onValidateRequiredFields(){
    return (!!payment_source && amount.length > 0) && paySimpleCardValid;
  }

  function onSubmit(){
    dispatch({type: 'BEGIN_SUBMIT_MAKE_PAYMENT'})
    if (payment_source.kind === 'other_card') {
      createNewPaymentSource()
    } else {
      dispatch(submitMakePaymentForm(makePaymentForm))
    }
  }

  function createNewPaymentSource(){
    if (organization.payment_processor === "paysimple") {
      paySimplePMTRef.current.submit();
    } else {
      createNewStripePaymentSource();
    }
  }

  function createNewPaySimplePaymentSource(paySimple){
    $.ajax({
      url: `/organizations/${organization.name}/residents/${resident.id}/payment_sources/create_pay_simple_card.json`,
      method: "POST",
      data: {
        payment_source: {
          kind: "card",
          pay_simple_token_id: paySimple.payment_method_token,
        },
      },
      success: (payment_source) => {
        makePaymentWithSource(payment_source);
      },
      error: (xhr) => {
        const errors = $.parseJSON(xhr.responseText).errors;
        dispatch({ type: "FAILED_SUBMIT_MAKE_PAYMENT", payload: errors });
      },
    });
  }

  function createNewStripePaymentSource(){
    props.stripe.createToken({name: 'Name'}).then(stripeResponse=>{
      if (stripeResponse.error) {
        dispatch({type: 'FAILED_SUBMIT_MAKE_PAYMENT', payload: [stripeResponse.error.message]})
      } else {
        $.ajax({
          url: `/organizations/${organization.name}/residents/${resident.id}/payment_sources.json`,
          method: 'POST',
          data: {
            payment_source: {
              kind: 'card',
              stripe_token_id: stripeResponse.token.id,
              stripe_source_id: stripeResponse.token.card.id,
              last4: stripeResponse.token.card.last4,
              brand: stripeResponse.token.card.brand,
            }
          },
          success: (payment_source) => {
            makePaymentWithSource(payment_source)
          },
          error: xhr => {
            const response = $.parseJSON(xhr.responseText);
            const errors = response.errors;
            const otherErrors = response.base ? response.base.join(', ') : null;
            dispatch({
              type: 'FAILED_SUBMIT_MAKE_PAYMENT',
              payload: [errors, otherErrors].filter(n => n)
            })
          },
        });
      }
    })
  }

  function makePaymentWithSource(payment_source) {
    dispatch({type: 'ADD_PAYMENT_SOURCE', payload: payment_source})
    dispatch(updateMakePaymentFieldAction({payment_source}))
    dispatch(submitMakePaymentForm(makePaymentForm))
    const nowWithTimezone = getCurrentTimeWithCurrentTimezone();
    dispatch({ type: "UPDATE_RESIDENT_UPDATED_AT",
      payload: { resident_updated_at: nowWithTimezone }});
  }

  function onErrors(){
    return false
  }

  function onClose(){
    dispatch({type: 'RESET_MAKE_PAYMENT_FORM', payload: { show: false }})
  }

  function handleNewPaymentOptionClick(){
    dispatch({type: 'SET_NEW_PAYMENT_SOURCE_CALLBACK_ACTION', payload: { callback_action: 'UPDATE_MAKE_PAYMENT_UI'}})
    dispatch({type: 'UPDATE_MAKE_PAYMENT_UI', payload: { show: false } })
    dispatch({type: 'UPDATE_NEW_PAYMENT_SOURCE_FORM_UI', payload: { show: true } })
  }

  useEffect(()=>{
    dispatch(updateMakePaymentFieldAction({amount: balance}))
  },[id])

  
  return (
    <FormModal
      show={show}
      title="Make Payment"
      isSubmitting={is_submitting}
      errors={errors}
      submitButtonLabel="Make Payment"
      handleClose={onClose} 
      handleValidateRequiredFields={onValidateRequiredFields}
      handleSubmit={onSubmit}
      handleErrors={onErrors}>
      {!!id &&
        <div>
          { !!email && <FormInput
            disabled
            label="Payer Email"
            value={email}/>
          }
          { false &&
          <FormInput
            disabled
            label="Due Date"
            value={due_by}/>}
          <FormInput
            disabled
            label="Memo"
            value={name}/>
          <FormInput
            disabled
            label="Amount"
            value={amount}
            handleChange={(amount)=>updateMakePaymentFieldAction({amount})}
            />
          <FormInput
            type="date"
            label="Paid On"
            value={paid_at}
            minDate={moment(issued_at, "YYYY-MM-DD").format("MM/DD/YYYY")}
            maxDate={moment(max_current_date)}
            handleChange={(paid_at)=>updateMakePaymentFieldAction({ paid_at })}/>
          <SelectPaymentOptions 
            value={payment_source}
            hasCashOption
            hasCheckOption
            hasExternalOptions
            hasOtherOption
            hasScholarshipOption
            hasOtherCardOption
            showNewPaymentMethodButton={false}
            handleNewPaymentOptionClick={handleNewPaymentOptionClick}
            handlePaymentSourceChange={(payment_source)=>updateMakePaymentFieldAction({payment_source})}/>
          {payment_source && ['bank_account', 'other_card', 'card'].includes(payment_source.kind) && (
            <PaySimpleTransactionFee paymentSourceKind={payment_source.kind} />
          )}
          <FormInput
            label="Description"
            handleChange={(description)=>updateMakePaymentFieldAction({ description })}
            value={description}/>
          {
            payment_source && payment_source.kind === 'other_card' && (
              <>
                {organization.payment_processor === "paysimple" && (
                  <FormInput
                    ref={paySimplePMTRef}
                    setCardValidation={(bool) => setPaySimpleCardValid(bool)}
                    handlePaymentMethodSucceeded={createNewPaySimplePaymentSource}
                    dispatchTypePaymentMethodFailed='FAILED_SUBMIT_MAKE_PAYMENT'
                    labelClassName="font-weight-bold"
                    type="credit_card_paysimple"
                  />
                )}
                {organization.payment_processor === "stripe" && (
                  <FormInput type="credit_card_stripe" />
                )}
              </>
            )

          }
        </div>
      }
    </FormModal>
  )
}

export default injectStripe(MakePayment)
